.modal-card {
  // All corners rounded with 3px radius
  border-radius: 3px;
  overflow: hidden;

  // Size variations
  &.modal-small {
    width: 400px;
    max-width: 90vw;
  }

  &.modal-medium {
    width: 640px;
    max-width: 90vw;
  }

  &.modal-large {
    width: 960px;
    max-width: 95vw;
  }

  // Wide form-style modals that benefit from more horizontal room
  // (e.g. the print template editor). Grows with the viewport up to the cap.
  &.modal-xlarge {
    width: 1280px;
    max-width: 95vw;
  }

  // Mobile positioning (top of screen, not bottom sheet)
  @media screen and (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0 0 16px 16px;
    max-height: 90vh;

    // Full width at every size: the size variants above are more specific
    // than the bare `.modal-card` here and would keep their desktop width
    // (a small modal: 90vw, flush left).
    &.modal-small,
    &.modal-medium,
    &.modal-large,
    &.modal-xlarge {
      width: 100%;
      max-width: 100%;
    }

    .modal-card-body {
      max-height: calc(90vh - 120px);
      overflow-y: auto;
    }
  }

  // Opt-in: dock to the bottom of the screen instead (better thumb reach for
  // modals that are opened from a bottom-of-content action button).
  &.modal-bottom-sheet {
    @media screen and (max-width: 768px) {
      top: auto;
      bottom: 0;
      border-radius: 16px 16px 0 0;
    }
  }
}

// Ensure proper stacking and smooth animations
.modal {
  // Ensure modal appears above all other elements including cart indicator (z-index: 1000)
  z-index: 1100;

  &.is-active {
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
      align-items: flex-start;
    }
  }

  .modal-background {
    background-color: rgba(10, 10, 10, 0.86);
  }

  .modal-card-head {
    background-color: var(--theme-background-alt);
    border-bottom: 1px solid var(--theme-border);
    // Keeps a long title off the close button.
    gap: 0.75rem;
  }

  .modal-card-title {
    // Bulma's flex-shrink: 0 lets a long title run into the close button.
    flex-shrink: 1;
    min-width: 0;
    font-weight: 600;
    font-size: 1.25rem;
    color: var(--theme-text-strong);
  }

  .modal-card-body {
    padding: 1.5rem;
    background-color: var(--theme-background);
    color: var(--theme-text);
  }

  .modal-card-foot {
    background-color: var(--theme-background-alt);
    border-top: 1px solid var(--theme-border);
    justify-content: flex-end;
    gap: 0.5rem;
  }
}
